import { Crown, Gem, Medal } from "lucide-react";

export const VIP_STYLES = {
  Silver: { icon: Medal, cls: "border-slate-300/60 bg-slate-300/15 text-slate-200" },
  Gold: { icon: Crown, cls: "border-pazer-red/70 bg-pazer-red/15 text-pazer-red" },
  Platinum: { icon: Gem, cls: "border-cyan-200/70 bg-cyan-200/15 text-cyan-100" },
};

export function VipBadge({ tier, size = "sm", testid }) {
  const s = VIP_STYLES[tier];
  if (!s) return null;
  const Icon = s.icon;
  const big = size === "lg";
  return (
    <span data-testid={testid || `vip-badge-${tier.toLowerCase()}`} title={`${tier} VIP`}
      className={`inline-flex items-center gap-1 rounded-full border font-bold uppercase tracking-wider ${s.cls} ${big ? "px-3 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]"}`}>
      <Icon className={big ? "h-3.5 w-3.5" : "h-3 w-3"} /> {tier}
    </span>
  );
}
